import { useNavigate } from "react-router-dom";
import { VERSION } from "../../config/constants";
import { useAuth } from "../../contexts/auth";
import "./Footer.css";
import { useListManager } from "../../contexts/list.manager";

export function Footer({ showSignOut = false }) {
	const navigate = useNavigate();
	const { signOut, user } = useAuth();
	const { closeForm } = useListManager();

	function onSignOutClick() {
		closeForm();
		signOut();
		navigate("/login");
	}

	return (
		<div className="app-footer container">
			Bravas Tecnologia • {VERSION}
			{user && showSignOut && (
				<button type="button" onClick={onSignOutClick}>Sair</button>
			)}
		</div>
	);
}